import { render, staticRenderFns } from "./MentionBox.vue?vue&type=template&id=6d11e698&scoped=true&"
import script from "./MentionBox.vue?vue&type=script&lang=js&"
export * from "./MentionBox.vue?vue&type=script&lang=js&"
import style0 from "./MentionBox.vue?vue&type=style&index=0&id=6d11e698&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d11e698",
  null
  
)

export default component.exports